import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
import { format } from '@/@core/utils/string';
let CapacityDetailApi = class CapacityDetailApi {
    constructor(boHttp, urls) {
        this.boHttp = boHttp;
        this.urls = urls;
        this.getAccountCapacity = (user_id, tenant_id, refresh = false) => {
            const url = this.urls.getAccountCapacity;
            return this.boHttp.get({
                url,
                params: { refresh, user_id, tenant_id },
            });
        };
        this.getCompanyCapacity = (company_id, refresh = false) => {
            const url = format(this.urls.getCompanyCapacity, {
                company_id,
            });
            return this.boHttp.get({
                url,
                params: { refresh },
            });
        };
    }
};
CapacityDetailApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.CapacityDetailApiUrls)),
    __metadata("design:paramtypes", [Object, Object])
], CapacityDetailApi);
export { CapacityDetailApi };
